module.exports = __webpack_public_path__ + "img/cancel.6dfb7380.png";